var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:kff-cds;src:url(" + escape(require("fonts/kff-cds.eot?e1re96")) + ");src:url(" + escape(require("fonts/kff-cds.eot?e1re96")) + "#iefix) format(\"embedded-opentype\"),url(" + escape(require("fonts/kff-cds.woff?e1re96")) + ") format(\"woff\"),url(" + escape(require("fonts/kff-cds.ttf?e1re96")) + ") format(\"truetype\"),url(" + escape(require("fonts/kff-cds.svg?e1re96")) + "#kff-cds) format(\"svg\");font-weight:400;font-style:normal}i{font-family:kff-cds!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;margin-right:8px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icons__iconCopy__2G_DY:before{content:\"\\E904\"}.icons__iconNew__2BOnS:before{content:\"\\E905\"}.icons__iconPrint__31XWM:before{content:\"\\E906\"}.icons__iconShare__2joOx:before{content:\"\\E907\"}.icons__iconLink__1_6b9:before{content:\"\\E908\"}.icons__iconClose__2-u2m:before{content:\"\\E90A\"}.icons__iconLinkedin__3btoN:before{content:\"\\E90D\"}.icons__iconFacebook__eNTkK:before{content:\"\\E90B\"}.icons__iconTwitter__Jg3n0:before{content:\"\\E90C\"}.icons__iconInfo__2yV2H:before{content:\"\\E909\"}.icons__iconPlus__2zMGt:before{content:\"\\E903\"}.icons__iconEmail__34WfJ:before{content:\"\\E900\";font-size:14px;margin-top:-1px}.icons__iconDownload__3V1no:before{content:\"\\E901\"}.icons__iconMinus__1H05N:before{content:\"\\E902\"}", ""]);

// exports
exports.locals = {
	"iconCopy": "icons__iconCopy__2G_DY",
	"iconNew": "icons__iconNew__2BOnS",
	"iconPrint": "icons__iconPrint__31XWM",
	"iconShare": "icons__iconShare__2joOx",
	"iconLink": "icons__iconLink__1_6b9",
	"iconClose": "icons__iconClose__2-u2m",
	"iconLinkedin": "icons__iconLinkedin__3btoN",
	"iconFacebook": "icons__iconFacebook__eNTkK",
	"iconTwitter": "icons__iconTwitter__Jg3n0",
	"iconInfo": "icons__iconInfo__2yV2H",
	"iconPlus": "icons__iconPlus__2zMGt",
	"iconEmail": "icons__iconEmail__34WfJ",
	"iconDownload": "icons__iconDownload__3V1no",
	"iconMinus": "icons__iconMinus__1H05N"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./app/styles/icons.css
// module id = 757
// module chunks = 0